/**
 * Apply mask to date input (dd/mm/yyyy)
 * @param {string} value - The input value
 * @returns {string} - The masked value
 */
export const applyDateMask = (value) => {
  // Remove non-digits
  let digits = value.replace(/\D/g, "");
  
  // Limit to 8 digits (ddmmyyyy)
  digits = digits.substring(0, 8);
  
  // Apply mask
  if (digits.length > 4) {
    return `${digits.substring(0, 2)}/${digits.substring(2, 4)}/${digits.substring(4)}`;
  } else if (digits.length > 2) {
    return `${digits.substring(0, 2)}/${digits.substring(2)}`;
  }
  return digits;
};

/**
 * Validate date in dd/mm/yyyy format
 * @param {string} dateString - The date string to validate
 * @returns {boolean} - Whether the date is valid
 */
export const validateDate = (dateString) => {
  // Check if the date matches the format dd/mm/yyyy
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    return false;
  }
  
  // Extract day, month, and year
  const [day, month, year] = dateString.split('/').map(Number);
  
  // Check if month is valid (1-12)
  if (month < 1 || month > 12) {
    return false;
  }
  
  // Check if day is valid for the given month
  const daysInMonth = new Date(year, month, 0).getDate();
  if (day < 1 || day > daysInMonth) {
    return false;
  }
  
  return true;
};